import { render, staticRenderFns } from "@/modules/LifeInsure/templates/life-insures-list.html?vue&type=template&id=531f316a&scoped=true&"
import script from "@/modules/LifeInsure/scripts/life-insures-list.ts?vue&type=script&lang=js&"
export * from "@/modules/LifeInsure/scripts/life-insures-list.ts?vue&type=script&lang=js&"
import style0 from "@/modules/LifeInsure/styles/life-insures-list.scss?vue&type=style&index=0&id=531f316a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531f316a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VForm,VImg})
